module.exports = __webpack_public_path__ + "static/sec7-bg-sm-15f9ee881f8196c70294685e76facd2b.jpg";